import styled from 'styled-components';
import media from '../../../constants/media';
import DynamicRspImage from '../../base/images/dynamicRspImageBg';
import { A, H6 } from '../../base/typography';

export const Wrapper = styled.div`
	padding: 5.5rem 0;
`;
export const LocationImage = styled(DynamicRspImage)`
	${media.mobileOnly`
		padding-bottom: 60%;
	`}
	height: 100%;

	${({ image }) =>
		image &&
		`
        background-image: url(${image}), url('/dist/images/postbox/default.png');
    `}
`;

export const InfoHeading = styled(H6)`
	font-size: 1.8rem;
`;

export const LocationLink = styled(A)`
	display: flex;
	align-items: center;
	margin: 2.5rem 0;
	font-size: 1.6rem;

	svg {
		margin-right: 1rem;
	}
`;

export const ButtonWrapper = styled.div`
	margin-top: 3rem;
`;

export const Map = styled.div`
	display: none;
	${media.tablet`
		display: flex;
		height: 100%;
		width: 100%;
	`};
`;
